$(function () {

    if($$.isMobile){
        var sportPhone = '79530385974';// '79530385963';
        var detiPhone = '79530385977'; // '89530385977'; // '79530385977';
        var $actionButton = $('[js-header-action-button]');
        var direction = $actionButton.data('direction');
        var url = '';

        if(direction == 'sport'){
            url = 'https://wa.me/'+sportPhone;
        }else if(direction == 'kids'){
            url = 'https://wa.me/'+detiPhone;
        }

        $actionButton.text('Узнать стоимость').attr('href', url);

    }

    if (window.ontouchstart || navigator.maxTouchPoints || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
        $(':root').attr('touch', true);
    }

    var $registrationBlocks = $('.intro__item_registration, .info__block_registration');

    $('[js-registration-info]').on('click', function (e) {
        e.preventDefault();
        $registrationBlocks.eq(1).hide();
        $registrationBlocks.eq(0).show();
    });

    $('[js-registration-back]').on('click', function (e) {
        e.preventDefault();
        $registrationBlocks.eq(0).hide();
        $registrationBlocks.eq(1).show();


    });

    $('[data-masked="phone"]').inputmask("+7(999)-999-9999", {showMaskOnHover: false});


    $('[js-tariff-detail]').on('click', function (e) {
        e.preventDefault();
        $$.openModal('tariff-detail')
    });

    $('[js-input]').inputShadow();

    $('[js-club-slider]').each(function (index, el) {
    
        var $list = $(el).find('[js-slider-list]');
        var $prev = $(el).find('[js-slider-prev]');
        var $next = $(el).find('[js-slider-next]');
    
        $list.addClass('owl-carousel').owlCarousel({
            items: 1,
            dots: false,
            nav: true,
            navText: [$prev, $next],
            loop: true,
            mouseDrag: false,
            responsive: {
                0: {
                    margin: 58,
                    nav: false,
                    autoplay: false,
                    loop: false
                },
                900: {
                    margin: 48,
                    nav: true,
                    navSpeed: 600,
                    autoplaySpeed: 600,
                    autoplayTimeout: 7000,
                    autoplay: false
                }
            }
        });

        $prev.on('click', function(e) {
            e.preventDefault();
        });

        $next.on('click', function(e) {
            e.preventDefault();
        });
    
    });


});


$(function () {
    var $W = $(window);
    var $header = $('[js-header]');
    if (!$header.length) return false;

    var $logo_main = $header.find('[js-header-logo-main]');
    var $logo_small = $header.find('[js-header-logo-small]');
    var scrollTop = $W.scrollTop();
    var threshhold_logo;
    var threshhold_filled;
    var resizeTimer;

    function update() {
        threshhold_logo = $W.width() > 800 ? ($logo_main.offset().top + $logo_main.height()) : 40;
        threshhold_filled = $W.width() > 800 ? ($logo_main.offset().top - $logo_main.height() + 10) : 40;
    }

    update();

    $W.off('.header-scroll').on({
        'load.header-scroll': function () {
            update()
        },
        'resize.header-scroll': function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                update();
            }, 300);
        },
        'scroll.header-scroll': function () {
            scrollTop = $W.scrollTop();
            if (scrollTop > threshhold_filled && !$header.hasClass('header_filled')) {
                $header.addClass('header_filled');
            }
            else if (scrollTop < threshhold_filled && $header.hasClass('header_filled')) {
                $header.removeClass('header_filled');
            }
            if (scrollTop > threshhold_logo && !$header.hasClass('header_show_logo')) {
                $header.addClass('header_show_logo');
            }
            else if (scrollTop < threshhold_logo && $header.hasClass('header_show_logo')) {
                $header.removeClass('header_show_logo');
            }
        }
    });
});

